import Api from '@common/oneclub/services/http'
import { promoteUrl } from '@common/oneclub/services/url'

export const getPromoteInfoApi = (data) => Api.normal.post(promoteUrl.getPromoteInfo, data)
